import posthog from "posthog-js";

const token = process.env.REACT_APP_POSTHOG_TOKEN ?? "";

export function initializePostHog() {
  return posthog.init(token, {
    api_host: "https://us.i.posthog.com",
    person_profiles: "always",
  });
}
